import { render, staticRenderFns } from "./Currentpzns.vue?vue&type=template&id=3fe6f8ae"
import script from "./Currentpzns.vue?vue&type=script&lang=js"
export * from "./Currentpzns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports